import {
  ISerialisedDocumentReference,
  ISerialisedTimestamp,
} from '@principle-theorem/shared';
import {
  IBigQueryFirestoreModel,
  IBigQueryNamedDocument,
  IBigQueryReffable,
  ITimestampedDimension,
} from './common';

export interface IAccountCreditDimension
  extends IBigQueryReffable,
    IBigQueryFirestoreModel,
    ITimestampedDimension {
  description: string;
  amount: number;
  type: string; // AccountCreditType
  reference?: string;
  invoice?: ISerialisedDocumentReference;
  depositUid?: string;
  reservedFor: IBigQueryReservedFor;
  used: number;
  issued?: ISerialisedTimestamp;
}

interface IBigQueryReservedFor {
  practitioner?: IBigQueryNamedDocument;
  treatment?: IBigQueryNamedDocument[];
}
